var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurpleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Frame_1064",
    "data-name": "Frame 1064",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame_1064_Background_Mask_",
    "data-name": "Frame 1064 (Background/Mask)",
    width: 80,
    height: 80,
    rx: 40,
    fill: "#9757d7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Frame_1064_Background_Mask_2",
    "data-name": "Frame 1064 (Background/Mask)",
    d: "M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0Z",
    fill: "#9757d7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame_1064-2",
    "data-name": "Frame 1064",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons_Wallet_Line",
    "data-name": "icons/Wallet/Line",
    transform: "translate(29 31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M18,18H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0H18a4,4,0,0,1,4,4V14A4,4,0,0,1,18,18ZM4,2A2,2,0,0,0,2,4V14a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2Z",
    transform: "translate(0)",
    fill: "#fcfcfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M5,0H9A1,1,0,0,1,9,2H5A3,3,0,0,0,5,8H9a1,1,0,0,1,0,2H5A5,5,0,0,1,5,0Z",
    transform: "translate(12 4)",
    fill: "#fcfcfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2Z",
    transform: "translate(16 8)",
    fill: "#fcfcfd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleIcon);
export default __webpack_public_path__ + "static/media/purple_icon.1ccb84b26e7bda6c0afbb70704650e25.svg";
export { ForwardRef as ReactComponent };